import useAppInfo from '../hooks/useAppInfo';

export const withAppInfo = Component => props => {
  const appInfo = useAppInfo();
  return <Component appInfo={appInfo} {...props} />;
};
